import { SVGProps } from 'react'

export const AdminApproval = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/*@ts-ignore*/}
    <g>
      <rect x="3" y="3" width="40" height="40" rx="20" fill="#F2F4F7" />
      <rect
        x="3"
        y="3"
        width="40"
        height="40"
        rx="20"
        stroke="#F9FAFB"
        strokeWidth="6"
      />
      <path
        d="M26.3332 17.1667L27.9998 18.8333L31.3332 15.5M31.3332 23V27.3333C31.3332 28.7335 31.3332 29.4335 31.0607 29.9683C30.821 30.4387 30.4386 30.8212 29.9681 31.0608C29.4334 31.3333 28.7333 31.3333 27.3332 31.3333H18.6665C17.2664 31.3333 16.5663 31.3333 16.0315 31.0608C15.5611 30.8212 15.1787 30.4387 14.939 29.9683C14.6665 29.4335 14.6665 28.7335 14.6665 27.3333V18.6667C14.6665 17.2665 14.6665 16.5665 14.939 16.0317C15.1787 15.5613 15.5611 15.1788 16.0315 14.9391C16.5663 14.6667 17.2664 14.6667 18.6665 14.6667H22.9998M14.7878 29.6053C15.1787 28.1988 16.4686 27.1667 17.9996 27.1667H23.833C24.6074 27.1667 24.9946 27.1667 25.3166 27.2307C26.6389 27.4937 27.6726 28.5274 27.9356 29.8497C27.9996 30.1717 27.9996 30.5589 27.9996 31.3333M24.6665 20.9167C24.6665 22.7576 23.1741 24.25 21.3332 24.25C19.4922 24.25 17.9998 22.7576 17.9998 20.9167C17.9998 19.0757 19.4922 17.5833 21.3332 17.5833C23.1741 17.5833 24.6665 19.0757 24.6665 20.9167Z"
        stroke="#667085"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)
